<template>
  <div class="c-app flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="8">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <CForm>
                  <img
                    class="navbar-brand-full"
                    src="img/login_logo.png"
                    alt="Apache Logo"
                    height="50"
                    width="150"
                  />
                  <h1>Iniciar Sesión</h1>
                  
                   <p class="text-muted">Introduce tus datos</p>
                  <CInput
                    placeholder="Username"
                    autocomplete="username email"
                    v-model="user"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="password"

                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" @click="handleLogin"
                        :disabled="isLoading" class="px-4"> <span v-if="!isLoading">Entrar</span>
                        <semipolar-spinner
                          :animation-duration="2000"
                          :size="30"
                          color="#ffffff"
                          v-if="isLoading"
                        >Entrar</semipolar-spinner></CButton>
                    </CCol>
                    <CButton @click="googleLogin()" color="primary">Continuar con Google</CButton>
                    <!--<CCol col="6" class="text-right">
                      <CButton color="link" class="px-0">Forgot password?</CButton>
                      <CButton color="link" class="d-lg-none">Register now!</CButton>
                    </CCol>-->
                  </CRow>
                  
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              no-body
                class="text-white bg-primary py-5 d-md-down-none"
                style="width:44%; 
                background:url('img/lapto.jpg');
                background-position: center;
                background-repeat: no-repeat;
                background-size: cover"
            >
              <!--<CCardBody
                
              >
                <h2>Sign up</h2>
                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                >
                  Register Now!
                </CButton>
              </CCardBody>-->
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
    <div class="centrado">
      <modal name="error" :width="300" :height="200" :adaptative="true">
        <div class="centrado">
        <p class="textMargin">El usuario y/o contraseña son incorrectos</p>
        <CButton color="primary" @click="hide" class="px-4">Cerrar</CButton>
      </div>
      </modal>
    </div>
  </div>
  
</template>

<script>
import { SemipolarSpinner } from "epic-spinners";
import VModal from "vue-js-modal";
import GoogleSignInButton from 'vue-google-identity-login-btn';

import postLogin from "../../api";
import store from "../../store";


export default {
  name: 'Login',
  
  components: {
    SemipolarSpinner
  },
  data() {
    return {
      user: "",
      password: "",
      // user: "rohit@spliceglobal.com",
      // password: "Sgspl)(*&6543",
      isLoading: false,
      err: false,
      url: "",
    };
  },
  computed(){
    console.log("esto funciona?")
    this.checkUrl()
  },
  
  methods: {
    
    googleLogin(){
      var environment = 'https://accounts.google.com/o/oauth2/auth?response_type=token&client_id=898194375391-q1tc54u2b0of21d6kf3fc8u624tpoujh.apps.googleusercontent.com&redirect_uri=https://martech-api.apachedigital.io/front/signin&scope=openid+profile+email&state=%7B%22d%22%3A%22odoo15%22%2C%22p%22%3A3%2C%22r%22%3A%22https%3A%2F%2Fmartech-app.apachedigital.io%2F%23%2Fhome%22%2C%20%22v%22%3A%22production%22%7D';
      if(window.location.hostname == 'localhost'){
      environment = 'https://accounts.google.com/o/oauth2/auth?response_type=token&client_id=898194375391-q1tc54u2b0of21d6kf3fc8u624tpoujh.apps.googleusercontent.com&redirect_uri=https://martech-api-staging.apachedigital.io/front/signin&scope=openid+profile+email&state=%7B%22d%22%3A%22odoo15-staging%22%2C%22p%22%3A3%2C%22r%22%3A%22https%3A%2F%2Fmartech-app-staging.apachedigital.io%2F%23%2Fhome%22%2C%20%22v%22%3A%22staging%22%7D';
      }else if (window.location.hostname.indexOf('staging') > -1) {
      // environment = 'production';
      environment = 'https://accounts.google.com/o/oauth2/auth?response_type=token&client_id=898194375391-q1tc54u2b0of21d6kf3fc8u624tpoujh.apps.googleusercontent.com&redirect_uri=https://martech-api-staging.apachedigital.io/front/signin&scope=openid+profile+email&state=%7B%22d%22%3A%22odoo15-staging%22%2C%22p%22%3A3%2C%22r%22%3A%22https%3A%2F%2Fmartech-app-staging.apachedigital.io%2F%23%2Fhome%22%2C%20%22v%22%3A%22staging%22%7D';
      }else{
      environment = 'https://accounts.google.com/o/oauth2/auth?response_type=token&client_id=898194375391-q1tc54u2b0of21d6kf3fc8u624tpoujh.apps.googleusercontent.com&redirect_uri=https://martech-api.apachedigital.io/front/signin&scope=openid+profile+email&state=%7B%22d%22%3A%22odoo15%22%2C%22p%22%3A3%2C%22r%22%3A%22https%3A%2F%2Fmartech-app.apachedigital.io%2F%23%2Fhome%22%2C%20%22v%22%3A%22production%22%7D';
      // environment = 'staging';
      }
      this.url = environment
      console.log("Llega la url?",this.url)
      window.location.href = this.url
    },
    show(){
      this.$modal.show("error")
    },
    hide(){
      this.$modal.hide("error")
    },
    handleLogin() {
      this.isLoading = true;
      let user = this.user;
      let password = this.password;
      store
        .dispatch("login", { user, password })
        .then(() => {
          const res = store.getters.getAuthStatus;
          if (res == "success") {
            this.isLoading = true;
            this.$router.push("/home");
          } else {
            this.isLoading = false;
            this.err = true;
            this.show()
          }
        })
        .catch(err => console.log(err));
     }
  }
}
</script>

<style>
.centrado{
  display: flex;
  flex-direction: column;
  align-content: center;
  align-items: center;
  justify-content: space-between;
}
.textMargin{
  margin-top: 30px;
  padding-top: 30px;
}
</style>